// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"_-_-pharmacy-src-answer-writeAnswer-disclosurePrompt__buttonGroup--2NbYG","button":"_-_-pharmacy-src-answer-writeAnswer-disclosurePrompt__button--2O4pY"};